import { render, staticRenderFns } from "./contract_personParty_sales.vue?vue&type=template&id=3836d4c0"
import script from "./contract_personParty_sales.vue?vue&type=script&lang=js"
export * from "./contract_personParty_sales.vue?vue&type=script&lang=js"
import style0 from "./contract_personParty_sales.vue?vue&type=style&index=0&id=3836d4c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports